import * as React from 'react';

import MultipleChoice from 'components/form/fields/MultilpleChoise/MultipleChoice';
import LanguagesList from 'components/language-switcher/LanguagesList';
import { countries } from 'config/countries';

export const gridConfig = {
  columns: [
    { name: 'name', title: 'Name', disabled: true },
    {
      component: ({ value }: any) => <LanguagesList languages={value} />,
      name: 'languages',
      title: 'Languages',
    },
  ],
  title: 'Countries',
};

export const formConfig = {
  fields: [
    {
      component: MultipleChoice,
      name: 'languages',
      title: 'Languages',

      options: countries,
    },
  ],
};
